import React from "react";

import {
    Map,
    TileLayer,
    ZoomControl,
} from "react-leaflet";
import { MAP_DEFAULT_VIEWPORT } from "../../config/constants";

const Maps = (props) => {
    const position = [MAP_DEFAULT_VIEWPORT.lat, MAP_DEFAULT_VIEWPORT.lng];
    return (
        <div style={{ height: "calc(100vh - 200px)", width: "100%" }}>
            <Map
                id="map-view"
                center={position}
                zoom={props.zoom}
                onZoom={props.onZoom}
                viewport={props.viewport}
                style={{ height: "100%", width: "100%", zIndex: 1 }}
                zoomControl={false}
                onClick={props.onClick}
                onMove={props.onMove}
            >
                <TileLayer
                    url="//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' />
                {props.markers}
                <ZoomControl position={"bottomright"} />
            </Map>
        </div>
    );
};

export default Maps;
